import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTournamentResults } from '../../api/tournament';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import LoadingSpinner from '../../components/LoadingSpinner';

const MEDALS = ['🥇', '🥈', '🥉'];

const TournamentResultsPage = () => {
    const { tournamentID } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                const results = await fetchTournamentResults(tournamentID);
                setData(results);
            } catch {
                toast.error('Failed to load tournament results');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [tournamentID]);

    if (loading) return <LoadingSpinner />;
    if (!data) return <div className="tournament-results-empty">Tournament not found.</div>;

    const { tournament, entries } = data;

    return (
        <div className="tournament-results-page">
            <div className="tournament-results-header">
                <button className="less-action" onClick={() => navigate('/tournament')}>
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                </button>
                <h2>{tournament.name}</h2>
                <span className={`tournament-status status-${tournament.status}`}>{tournament.status}</span>
            </div>

            <div className="tournament-results-table-wrapper table-scroll-wrapper">
                <table className="tournament-results-table">
                    <thead>
                        <tr>
                            <th className="col-rank">#</th>
                            <th className="col-player">Player</th>
                            <th className="col-team">Team</th>
                            <th className="col-elo">ELO</th>
                            <th className="col-record">Record</th>
                            <th className="col-tier">Tier</th>
                            <th className="col-rewards">Rewards</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((entry) => {
                            const isComputer = !entry.userID;
                            const rankClass = entry.rank <= 3 ? `rank-${entry.rank}` : '';
                            return (
                                <tr key={entry.tournamentEntryID} className={`${rankClass} ${isComputer ? 'computer-entry' : ''}`}>
                                    <td className="col-rank">
                                        {entry.rank <= 3 ? MEDALS[entry.rank - 1] : entry.rank}
                                    </td>
                                    <td className="col-player">
                                        {isComputer ? (
                                            <span className="computer-label">
                                                <FontAwesomeIcon icon={faRobot} /> CPU
                                            </span>
                                        ) : (
                                            <a href={`/u/${entry.User?.username}`} target="_blank" rel="noopener noreferrer">{entry.User?.username ?? 'Unknown'}</a>
                                        )}
                                    </td>
                                    <td className="col-team">{entry.UserTeam?.name ?? '—'}</td>
                                    <td className="col-elo">{entry.currentElo}</td>
                                    <td className="col-record">{entry.wins}W-{entry.losses}L</td>
                                    <td className="col-tier">
                                        {entry.rewardTier ? (
                                            <span className={`tier-badge tier-${entry.rewardTier}`}>
                                                {entry.rewardTier}
                                            </span>
                                        ) : '—'}
                                    </td>
                                    <td className="col-rewards">
                                        {isComputer ? '—' : (entry.rewardDescription ?? '—')}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TournamentResultsPage;
